module.exports = __webpack_public_path__ + "img/Frame_ItemFrame01_Color_Green.24d918ba.png";